document.addEventListener("DOMContentLoaded", () => {
  const isMobile = () => {
    return 'ontouchstart' in document.documentElement
         || navigator.maxTouchPoints > 0
         || navigator.msMaxTouchPoints > 0;
  }

  const colorSwatches = document.querySelectorAll(".product__color-swatch")

  // return early if no color swatches are found
  if (!colorSwatches || colorSwatches.length === 0) {
    return
  }

  const dataCache = {}
  const currentProductMedia = document.querySelector(".product__primary-left")
  const currentOptionValue = document.querySelector(
    "[data-current-option-value]"
  )
  const currentProductMediaHtml = currentProductMedia?.innerHTML
  const currentOptionValueHtml = currentOptionValue?.innerHTML

  const updatePageContent = async (swatchLink) => {
    const swatchProduct = await fetchSwatchProduct(swatchLink)

    // replace the current product media and option value with the new ones
    if (currentProductMedia && swatchProduct.media) {
      currentProductMedia.innerHTML = swatchProduct.media
    }
    if (currentOptionValue && swatchProduct.optionValue) {
      currentOptionValue.innerHTML = swatchProduct.optionValue
    }
  }

  const fetchSwatchProduct = async (swatchLink) => {
    const cacheContent = dataCache[swatchLink]
    if (cacheContent) {
      // if the content is already cached, no need to fetch again
      return cacheContent
    }

    // fetch the swatch link content
    // const swatchLinkReq = await fetch(`${swatchLink}?section_id=main-product--default`)
    const swatchLinkReq = await fetch(swatchLink)

    // handle fetch errors
    if (!swatchLinkReq.ok) {
      console.error(`Failed to fetch swatch link: ${swatchLink}`)
      return
    }

    const swatchLinkHtml = await swatchLinkReq.text()
    // create a temporary DOM element to parse the HTML
    const tempDiv = new DOMParser().parseFromString(swatchLinkHtml, 'text/html');

    // find the new product media and option value in the fetched content
    const newProductMedia = tempDiv.querySelector(".product__primary-left")
    const newOptionValue = tempDiv.querySelector("[data-current-option-value]")

    dataCache[swatchLink] = {
      media: newProductMedia ? newProductMedia.innerHTML : "",
      optionValue: newOptionValue ? newOptionValue.innerHTML : "",
    }

    return dataCache[swatchLink]
  }

  // Add hover event listeners to color swatches
  colorSwatches.forEach((swatch) => {
    const swatchLink = swatch.href

    // return early if swatch link is not defined or is the same as the current page URL
    if (!swatchLink || swatchLink === window.location.href) {
      return
    }

    // prefetch the swatch product content
    fetchSwatchProduct(swatchLink)

    // replace image and option value on hover
    swatch.addEventListener("mouseover", async (e) => {
      if (!isMobile()) {
        e.preventDefault()

        updatePageContent(swatchLink)
      }
    })

    // revert image and option value on mouseout
    swatch.addEventListener("mouseout", () => {
      currentProductMedia.innerHTML = currentProductMediaHtml
      currentOptionValue.innerHTML = currentOptionValueHtml
    })
  })
})
